import React from 'react';
import { Line } from 'react-chartjs-2';

const TCF_Area1 = require('../../Resources/Data/TCF_Area_1.json')
const TCF_Area2 = require('../../Resources/Data/TCF_Area_2.json')
const TCF_Area3 = require('../../Resources/Data/TCF_Area_3.json')

const TCF = { Area1: TCF_Area1, Area2: TCF_Area2, Area3: TCF_Area3 }

const nat = ["France", "Belgium", "United Kingdom", "United States", "Italy", "Spain", "Germany", "Switzerland"]
var colors = [
    { r: 255, g: 0, b: 0 },
    { r: 0, g: 255, b: 0 },
    { r: 0, g: 0, b: 255 },

    { r: 64, g: 64, b: 200 },
    { r: 200, g: 64, b: 64 },
    { r: 64, g: 200, b: 64 },

    { r: 64, g: 255, b: 255 },
    { r: 255, g: 255, b: 64 },
    { r: 255, g: 255, b: 64 },
]

function getRGBA(color, alpha) {
    return `rgba(${color.r},${color.g},${color.b},${alpha})`
}

function GenerateData(ar, ag) {
    var datas = {}
    datas.labels = [2013, 2014, 2015, 2016, 2017, 2018]
    datas.datasets = []
    for (let i = 0; i < nat.length; i++) {
        datas.datasets.push({
            label: nat[i],
            backgroundColor: getRGBA(colors[i], 0),
            borderColor: getRGBA(colors[i], 0.5),
            pointBackgroundColor: getRGBA(colors[i], 1),
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            lineTension: 0.1,
            pointHoverBorderColor: getRGBA(colors[i], 1),
            data: []
        })
    }
    var file
    var result
    if (ar === 'Area1') { file = TCF.Area1.Area_1.find((element => { return (element.name === global.name_area) })); }
    if (ar === 'Area2') { file = TCF.Area2.Area_2.find((element => { return (element.name === global.name_area) })); }
    if (ar === 'Area3') { file = TCF.Area3.Area_3.find((element => { return (element.name === global.name_area) })); }
    if (file) {
        if (ag === 'Area2') {
            if(file.Aggregation.area_2) result = file.Aggregation.area_2.find((element => { return (element.name === global.name_ag) }))
        }
        if (ag === 'Area3') {
            if(file.Aggregation.area_3) result = file.Aggregation.area_3.find((element => { return (element.name === global.name_ag) }))
        }
        if (ag === 'Area4') {
            if(file.Aggregation.area_4) result = file.Aggregation.area_4.find((element => { return (element.name === global.name_ag) }))
        }
    }
    if (result)
        result.TCF.forEach((element) => {
            var i1 = nat.indexOf(element.nat)
            var i2 = datas.labels.indexOf(element.year)
            if (i1 !== -1 && i2 !== -1) {
                datas.datasets[i1].data[i2] = element.TCF
            }
        })
    return datas
}




export default class GCF_Line extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
        this.state.ar = this.props.ar;
        this.state.ag = this.props.ag;
        this.state.data = GenerateData(this.state.ar, this.state.ag);
    }

    static getDerivedStateFromProps(props, state) {
      //componentWillReceiveProps() {
        this.setState(state => {
            state.ag = global.ag
            state.ar = global.ar
        })
    }

    getLabel() {
        if (this.state.ag === 'Area2') return 'Departments'
        if (this.state.ag === 'Area3') return 'Districts'
        if (this.state.ag === 'Area4') return 'Cities'
    }

    render() {
        return (
            <div>
                <h2>TCF Chart of {global.name_ag}</h2>
                <Line data={GenerateData(this.state.ar, this.state.ag)} />
            </div>
        );
    }
}
